import { VerticalRectangleWithCustomRadius } from './VerticalRectangleWithCustomRadius';
import {
  BAR_BOTTOM_RADIUS,
  BAR_TOP_LEFT_RADIUS,
  SMALL_BAR_RADIUS,
  getTopRightRadius,
} from './constants';

// if one bar has an image, all bars must be of the same height
// meaning that they need to take the height of the image into account even if they don't have an image
// in that case there is the imageUrl property but it is undefined
type BarImage = { imageUrl: string | undefined } | undefined;

interface Bar {
  color: string;
  x: number;
  y: number;
  width: number;
  height: number;
  image?: BarImage;
  opacity?: number;
  disableAnimations?: boolean;
}

export const Bar = ({
  color,
  x,
  y,
  width,
  height,
  image,
  opacity = 1,
  disableAnimations = false,
}: Bar) => {
  const topRightRadius = getTopRightRadius(width);
  const colorRectangleHeight = height;

  if (image) {
    const imageHeight = width;
    const imageWidth = width;

    const colorRectangleY = y;

    return (
      <>
        <VerticalRectangleWithCustomRadius
          data-testid="image-rectangle"
          background={image.imageUrl ? { image: image.imageUrl } : { color }}
          x={x}
          y={colorRectangleY - imageHeight + 1}
          width={imageWidth}
          height={imageHeight}
          topRightRadius={topRightRadius}
          topLeftRadius={BAR_TOP_LEFT_RADIUS}
          animateFromY={
            // initialY of the bar below - imageHeight
            // const initialY = y + height - maxTotalVerticalRadius;
            colorRectangleY +
            colorRectangleHeight -
            BAR_BOTTOM_RADIUS -
            imageHeight
          }
          disableAnimations={disableAnimations}
          opacity={opacity}
        />
        <VerticalRectangleWithCustomRadius
          data-testid="color-rectangle"
          background={{ color }}
          x={x}
          y={colorRectangleY}
          width={width}
          height={colorRectangleHeight}
          bottomLeftRadius={BAR_BOTTOM_RADIUS}
          bottomRightRadius={BAR_BOTTOM_RADIUS}
          disableAnimations={disableAnimations}
          opacity={opacity}
        />
      </>
    );
  }

  const minPossibleHeightForPath = topRightRadius + BAR_BOTTOM_RADIUS;
  const canRenderPath = colorRectangleHeight >= minPossibleHeightForPath;

  if (!canRenderPath) {
    return (
      <rect
        data-testid="rect-rectangle"
        x={x}
        y={y}
        width={width}
        height={colorRectangleHeight}
        rx={SMALL_BAR_RADIUS}
        ry={SMALL_BAR_RADIUS}
        fill={color}
        opacity={opacity}
      />
    );
  }

  return (
    <VerticalRectangleWithCustomRadius
      data-testid="rectangle"
      background={{ color }}
      x={x}
      y={y}
      width={width}
      height={colorRectangleHeight}
      topRightRadius={topRightRadius}
      topLeftRadius={BAR_TOP_LEFT_RADIUS}
      bottomLeftRadius={BAR_BOTTOM_RADIUS}
      bottomRightRadius={BAR_BOTTOM_RADIUS}
      disableAnimations={disableAnimations}
      opacity={opacity}
    />
  );
};
